import React, { useState } from 'react';
import { FaEdit, FaTrash, FaEnvelope, FaMapMarkerAlt, FaCheckCircle, FaExclamationCircle, FaBriefcase, FaUser, FaPhone } from 'react-icons/fa';
import { User } from '../../hook/types/users';
import { useUsers } from '../../hook/useUsers';
import toast from 'react-hot-toast';
// type Tenant = {
//   id: number;
//   name: string;
//   contact: string;
//   email: string;
//   propertyAddress: string;
//   dueDate: string;
//   occupiedDate: string;
//   rentStatus: string;
//   depositAmount: number;
//   rent: number;
//   occupation: string;
//   documentUrl: string | null;
//   comments: string;
//   tenantImageUrl: string | null;
//   active: boolean;
// };

const TenantCard = ({
  tenant,
  onViewDetails,
  onEdit,
  onDelete,
}: {
  tenant: Tenant;
  onViewDetails: () => void;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const {queryClient} = useUsers()
  const uid = localStorage.getItem("R_M_uid") 
    const userData = queryClient.getQueryData(["users",uid])  as User;
  return (
    <div
      className=" hover:bg-green-100 hover:border-green-500 transition-all duration-300 ease-in-out rounded-xl shadow-md border border-gray-200 p-4 flex items-center transition-transform duration-300 transform relative w-full max-w-md"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Tenant Image */}
      <div className="relative mr-4">
        <img
          src={tenant?.tenantImageUrl || 'https://via.placeholder.com/120'}
          alt={tenant?.name}
          className="w-16 h-16 rounded-full border-2 border-gray-300"
        />
      </div>

      {/* Tenant Information */}
      <div className="flex-1">
      <h2 className="text-base font-semibold flex items-center">
          <FaUser className="mr-2 text-blue-500" /> {tenant.name}
        </h2>
        {tenant.occupation && (
          <p className="text-gray-500 text-sm flex items-center">
            <FaBriefcase className="mr-2 text-gray-500" /> {tenant.occupation}
          </p>
        )}
        {/* <p className="text-gray-500 text-sm flex items-center">
          <FaBriefcase className="mr-2 text-gray-500" /> {tenant.occupation}
        </p> */}
        <p className="text-gray-600 text-sm flex items-center">
          <FaPhone className="mr-1 text-gray-500" /> {tenant.contact}
        </p>
        {/* <p className="text-gray-600 text-sm flex items-center truncate">
          <FaMapMarkerAlt className="mr-1 text-red-500" /> {tenant.propertyAddress}
        </p> */}

        {/* Rent Status Badge */}
        {/* <span
          className={`inline-flex items-center mt-2 px-2 py-0.5 rounded-full text-xs font-semibold ${
            tenant.rentStatus === 'PAID'
              ? 'bg-green-100 text-green-600'
              : 'bg-red-100 text-red-600'
          }`}
        >
          {tenant.rentStatus === 'PAID' ? (
            <FaCheckCircle className="mr-1" />
          ) : (
            <FaExclamationCircle className="mr-1" />
          )}
          {tenant.rentStatus}
        </span> */}
      </div>

      {/* Edit and Delete Buttons (Visible on Hover) */}
      {userData?.roles[0]?.roleName==='ADMIN'? <div
        className={`absolute top-3 right-3 flex gap-2 transition-opacity duration-300 ${
          isHovered ? 'opacity-100' : 'opacity-0'
        }`}
      >
        <button
          onClick={onEdit}
          className="text-yellow-500 hover:text-yellow-600 transition-colors duration-200"
        >
          <FaEdit size={18} />
        </button>
        <button
          onClick={onDelete}
          className="text-red-500 hover:text-red-600 transition-colors duration-200"
        >
          <FaTrash size={18} />
        </button>
      </div>:null}
     

      {/* View Details Button */}
      <button
        onClick={onViewDetails}
        className="absolute bottom-3 right-3 bg-primary text-white px-4 py-2 rounded-xl text-sm hover:bg-green-600 transition-colors duration-200"
      >
        Details
      </button>
    </div>
  );
};

export default TenantCard;
